export default __webpack_public_path__ + "static/media/list_booth_okara.2a326dfe.svg";